


<app-website-header></app-website-header>

<div class="container-fluid">

        <section class="about">
            <div class="row">
                <div class="col-sm" style="height: 10px;"></div>
                <div class="col-md" style="height: 24px"></div>
            </div>
    
    
            <div class="row" >
                <div class="col-sm-1"></div>
    
                <div class="about-image">
                    <p style="object-fit: contain;
                    font-family: Raleway;
                    font-size: 45px;
                    font-weight: 600;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: 1.33;
                    letter-spacing: 0.32px;
                    text-align: left;
                    color: #ff6d11;">About Us</p>
                    <p style="margin-top:-33px;"><img src="assets/section-images/Path 336.png"> </p>
                </div>
    
                <div class="col-sm-1"></div>
            </div>
    
            <div class="row">
                <div class="col-sm" style="height: 10px;"></div>
                <div class="col-md" style="height: 24px"></div>
            </div>
            <div class="row" >
                <div class="col-sm-1"></div>
    
                <div class="col-sm-2" style="margin-left: -14px;">
                    <a href="what-are-we" class="services"><p style="color: #ff6d11;"> <span style="font-weight: bolder;color: #ff6d11;" > ></span> What Are We  </p></a>
                    <a href="vision-mission" class="services"><p> <span style="font-weight: bolder;"> > </span> Vision & Mission </p></a>
                    <a href="strategic-changes" class="services"><p> <span style="font-weight: bolder;" > ></span> Strategic changes </p></a>
                 </div>
    
    
                <div class="col-sm-7" style="margin-left: 105px;">
                    <p style="font-family: Raleway;
                    font-size: 24px;
                    font-weight: 500;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: 1.21;
                    letter-spacing: 0.24px;
                    text-align: left;
                    color: #ff6d11;" >What Are We</p>
                    <p style="object-fit: contain;
                    font-family: Raleway;
                    font-size: 16px;
                    font-weight: normal;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: 1.75;
                    letter-spacing: 0.13px;
                    text-align: left;
                    color: #000000;"> Evolv Tax is a team of dedicated and experienced professionals committed to delivering quality service to our esteemed clients. Our professional team has successfully assisted our clients in realizing the outsourcing benefit and delivering sustainable competitive advantage a head. Evolv Tax offers a wide range of tax services including tax planning, preparation, filing, ITIN Processing Guidance and Renewing ITIN Assistance, FBAR & FATCA Reporting To IRS, Form W4 GUIDANCE and other tax advisory services to both US & India Expats and Inpats. Our tax return preparation process undergoes scrupulous tests using true-to-life case scenarios simulated by our team of knowledge management professionals and more particularly adhering to specifications provided by the IRS in its publications before our services are being offered /provided to our valued customers
    
      <br> <br>  Evolv Tax designed a bouquet of end-to-end solutions to help the taxpayer file his/her income tax return with hassle free of mind. Our services facilitate the taxpayers to meet their tax obligations and administer their tax affairs in a trouble-free and cost-effective manner.
    
      <br> <br>The firm consists of a team of professionals including EAs, CAs, CMAs and other accounting professionals from premier institutes with diversified tax knowledge and business background. Our core team has gone through rigorous research in both the countries (US & India) tax laws & tax treaty agreements and gained expertise knowledge and achieved hands on experience in both US and India tax compliance areas. A team of dedicated, knowledgeable, and experienced individuals bring you US & India Tax under the same crown. We undertake the privilege to serve you better in your all future needs.
    
      <br> <br> Disclaimer: This Firm is not a CPA’s or any attorney’s Firm and not a Substitute for any of those.</p>
    
                       
                </div>
                <div class="col-sm-2"></div>
            </div>
    
            <div class="row">
                <div class="col-sm" style="height: 10px;"></div>
                <div class="col-md" style="height: 40px"></div>
            </div>
    
           
    
            <div class="row">
                <div class="col-sm" style="height: 10px;"></div>
                <div class="col-md" style="height: 50px"></div>
            </div>
    
        
            <div class="row">
                <div class="col-sm-1"></div>
    
                <div class="col-sm-5">
                    <p class="need-help">NEED HELP?</p> <br>
                    <p class="need-content">
                            Contact our customer support team if you have any further questions. We are here to help you out.
                    </p> <br>
    
                     <a href="tel:+1(737)637-6407">
                            <button class="btn  btn-sm Number" id="right" style="width: 250px;
                                        height: 50px;
                                        object-fit: contain;
                                        border-radius: 25px;
                                        background-color: #ff6d11;
                                        color: white;">
                            +1 (737) 637 - 6407 &nbsp;
                        </button>
                        </a>
                </div>
    
                <div class="col-sm-5">
                    <img src="assets/section-images/Group 1364.png">
                </div>
    
                <div class="col-sm-1"></div>
            </div>
    
            <div class="row">
                    <!-- <div class="col" style="height: 1px;"></div> -->
                    <div class="col-sm" style="height: 10px;"></div>
                    <div class="col-md" style="height: 65px"></div>
                    <!-- <div class="col-lg" style="height: 150px;"></div> -->
                </div>
        </section>
    
    </div>

<app-website-footer></app-website-footer>
